export default "__VITE_ASSET__CQLgydis__"